import axios from "axios";

export const axiosInstance = axios.create({
    headers : {
        authorization : `Bearer ${localStorage.getItem('jwtToken')}`
    },
    timeout: 45000 // Timeout after 45 seconds
});